// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Y_CiwTGldMg3v63TyVPm {\r\n\tmargin: auto;\r\n}\r\n\r\n.S53gtOzFdtuqSSP7jEhn {\r\n\tpadding: auto;\r\n}\r\n", "",{"version":3,"sources":["webpack://./vendor.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd","sourcesContent":[".zzzz {\r\n\tmargin: auto;\r\n}\r\n\r\n.kkkk {\r\n\tpadding: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zzzz": "Y_CiwTGldMg3v63TyVPm",
	"kkkk": "S53gtOzFdtuqSSP7jEhn"
};
export default ___CSS_LOADER_EXPORT___;
